export enum LocaleEnum {
    Domestic = 1,
    Foreign = 2,
    OCONUS = 3
}

export enum ExpenseStatus {
    SuperUser = -1,
    Saved = 0.0,
    Signed = 1.0,
    Validated = 1.5,
    Approved = 2.0,
    Disapproved = 3.0
}

export enum PerDiemTypeEnum {
    Lodging = 1,
    MIE = 2,
    LocalMealRate = 4,
    ProportionalMealRate = 5,
    LocalIncidental = 6,
    BothLodgingandMIE = 7
}

export enum MileageTypeEnum {
    Airplane = 1,
    POV = 2,
    GOV = 3,
    Motorcycle = 4
}

export enum TravelTypeEnum {
    Unknown = -1,
    PerDiem = 2,
    Mileage = 3,
    Receipt = 4
}
export enum ExpenseRequestTypeEnum {
    Expense = 1,
    Travel = 2
}
